import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-share',
  templateUrl: './modal-share.component.html',
  styleUrls: ['./modal-share.component.scss']
})
export class ModalShareComponent implements OnInit {

  @Input() fromParent: any;
  public isOpenToast: boolean = false;
  constructor(private activeModal: NgbActiveModal, private clipboard: Clipboard) { }

  ngOnInit(): void {}

  public closeModal(): void {
    this.activeModal.close();
  }

  public printDocument(): void {
    this.activeModal.close();
    window.print();
  }

  public openToast(): void {
    this.isOpenToast = true;
    this.clipboard.copy(window.location.href);
    setTimeout(() => {
      this.isOpenToast = false;
    }, 3000);
  }

}
